import { ChallengeReason, Challenge, ChallengePrompt, ChallengeValidation, } from '../../Challenge';
import { ChallengeStrings } from '../../Strings/Messages';
import { Result } from '@standardnotes/domain-core';
export class AuthorizeVaultDeletion {
    constructor(vaultLocks, protection, challenges, _validateVaultPassword) {
        this.vaultLocks = vaultLocks;
        this.protection = protection;
        this.challenges = challenges;
        this._validateVaultPassword = _validateVaultPassword;
    }
    async execute(vault) {
        if (!this.vaultLocks.isVaultLockable(vault)) {
            const authorized = await this.protection.authorizeAction(ChallengeReason.Custom, {
                fallBackToAccountPassword: true,
                requireAccountPassword: false,
                forcePrompt: true,
            });
            return Result.ok(authorized);
        }
        const challenge = new Challenge([new ChallengePrompt(ChallengeValidation.None, undefined, 'Password')], ChallengeReason.Custom, true, ChallengeStrings.DeleteVault(vault.name), ChallengeStrings.EnterVaultPassword);
        return new Promise((resolve) => {
            this.challenges.addChallengeObserver(challenge, {
                onCancel() {
                    resolve(Result.ok(false));
                },
                onNonvalidatedSubmit: async (challengeResponse) => {
                    const value = challengeResponse.getDefaultValue();
                    if (!value) {
                        this.challenges.completeChallenge(challenge);
                        resolve(Result.ok(false));
                        return;
                    }
                    const password = value.value;
                    if (this.vaultLocks.isVaultLocked(vault)) {
                        const unlocked = await this.vaultLocks.unlockNonPersistentVault(vault, password);
                        if (unlocked) {
                            this.challenges.completeChallenge(challenge);
                            resolve(Result.ok(true));
                            return;
                        }
                    }
                    const validPassword = this._validateVaultPassword.execute(vault, password).getValue();
                    if (!validPassword) {
                        this.challenges.setValidationStatusForChallenge(challenge, value, false);
                        resolve(Result.ok(false));
                        return;
                    }
                    this.challenges.completeChallenge(challenge);
                    resolve(Result.ok(true));
                },
            });
            void this.challenges.promptForChallengeResponse(challenge);
        });
    }
}
